import _ from "lodash";

export class Utils {

    /**
     * AngularJS implementation of isDefined
     *
     * @param value
     */
    static isDefined(value: any): boolean {
        return typeof value !== "undefined";
    }

    // eslint-disable-next-line sonarjs/public-static-readonly
    static diff = <T, TOther>(
        source: T[],
        other: TOther[],
        selfSelector: (sel: T) => string,
        otherSelector: (otherSel: TOther) => string) => {
        const sourceKeys = source.map(selfSelector);
        const otherKeys = other.map(otherSelector);

        const matched = source.map((item) => {
            const found = other.find((element) => otherSelector(element) === selfSelector(item));

            if (!found) {
                return undefined;
            }

            return {
                source: item,
                other: found
            };
        }).filter(s => s);

        const removes = source.filter((item) => {
            if (!otherKeys.includes(selfSelector(item))) {
                return item;
            }

            return undefined;
        });

        const adds = other.filter((item) => {
            if (!sourceKeys.includes(otherSelector(item))) {
                return item;
            }

            return undefined;
        });

        return {
            adds: adds,
            removes: removes,
            matched: matched
        } as IDiffResult<T, TOther>;
    };

    static download(textMessage: string, filename: string, type = "application/xml;charset=utf-8;"): void {
        const blob = new Blob([textMessage], { type });
        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = filename;
        downloadLink.click();
    }

    static downloadBlob(blob: Blob, filename: string): void {
        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = filename;
        downloadLink.click();
    }

    /**
     * Validerar om det är ett nummer eller om det nummer i strängformat ("11" eller 11)
     */
    static isNumberLike(value: any, isPositive: boolean) {
        if (_.isNumber(value) || !isNaN(value)) {
            if (isPositive) {
                return parseFloat(value) >= 0;
            }
            return true;
        }
        return false;
    }
}

export interface IDiffResult<T, TOther> {
    adds: TOther[];
    removes: T[];
    matched: IMatch<T, TOther>[];
}
export interface IMatch<T, TOther> {
    source: T;
    other: TOther;
}
